import React from 'react';
import { useFormikContext } from 'formik';

import { IconButton, Icons } from 'widget/components';
import { useIsFormDisabled } from '../hooks';
import { Values } from '../composer-env';

const Submit = () => {
  const { values } = useFormikContext<Values>();
  const isDisabled = useIsFormDisabled(values);

  return (
    <IconButton type="submit" isDisabled={isDisabled}>
      <Icons.PaperPlaneRight fill="gray" size={24} />
    </IconButton>
  );
};

export default Submit;
